__turbopack_context__.v({
  "article": "FZtKTa_article",
  "content": "FZtKTa_content",
  "content-block": "FZtKTa_content-block",
  "description": "FZtKTa_description",
  "featured-article": "FZtKTa_featured-article",
  "thumbnail": "FZtKTa_thumbnail",
  "thumbnail-wrapper": "FZtKTa_thumbnail-wrapper",
  "wrapper": "FZtKTa_wrapper",
});
